// settings/services/kfm-settings-page.service.ts
import { Injectable, inject, signal } from '@angular/core';
import { ISettingsPage, KFM_SETTINGS_PAGE } from './kfm-settings-token';

@Injectable({
  providedIn: 'root',
})
export class SettingsPageService {
  // Wir versuchen den Token zu injizieren.
  // { optional: true } verhindert den Fehler, falls noch kein Modul etwas registriert hat.
  private readonly providedPages = inject(KFM_SETTINGS_PAGE, {
    optional: true,
  });

  private readonly _pages = signal<ISettingsPage[]>([]);
  public readonly pages = this._pages.asReadonly();

  constructor() {
    if (this.providedPages) {
      // Da wir 'multi: true' nutzen, kommt ein Array zurück.
      // Wir flachen es ab, falls verschachtelte Arrays geliefert werden.
      const flatPages = Array.isArray(this.providedPages)
        ? this.providedPages.flat()
        : [this.providedPages];

      this._pages.set(flatPages);
    }
  }

  // Falls du später zur Laufzeit noch etwas hinzufügen willst
  register(page: ISettingsPage) {
    this._pages.update((current) => [...current, page]);
  }
}
